import i18next from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

import { convertDetectedLanguage, languageDetector } from './language-detector';
import { formatCurrency, formatNumber } from './numbers';

i18next
  .use(languageDetector)
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    backend: {
      backendOptions: [
        {
          loadPath: '/translations/{{ns}}/{{lng}}.json',
        },
        {
          // The libraries project uses this structure
          loadPath: '/lib-translations/{{lng}}/{{ns}}.json',
        },
      ],
      backends: [
        Backend, // primary
        Backend, // from libraries
      ],
    },
    debug: ENV_ID !== 'production',
    defaultNS: 'translations',
    detection: {
      convertDetectedLanguage,
    },
    fallbackLng: {
      default: ['en'],
    },
    interpolation: {
      escapeValue: false, // not needed for react!!
      format: (value, format, lng) => {
        if (format === 'currency') return formatCurrency(value, lng);
        if (format === 'number') return formatNumber(value, lng);
        return value;
      },
      formatSeparator: ',',
    },
    ns: ['translations', 'label-purchase-flow'],
  });

export default i18next;
